import { Box } from '@mui/material';
import React from 'react';
import type { Interpolation, Theme } from '@emotion/react';
import {
  Button,
  ButtonVariant,
} from '../../component_library/components/Button';
import type { IPropsWithTestId } from '../../constants/data-element-tracking-ids';
import { useOperationButton } from './hook';
import HtmlBox from '../../component_library/components/HtmlBox/HtmlBox';
import { WithdrawalStayEnrolledDialog } from '../abc/account/account-page-manage-election/withdrawal-section-module/withdrawal-stay-enrolled-dialog';
import type { HtmlFromDotcms } from '../../dotcms/dotcms-models/converters-from-dotcms';

interface IProps extends IPropsWithTestId {
  label?: HtmlFromDotcms | string;
  variant?: ButtonVariant;
  additionalStyles?: Interpolation<Theme>;
  disabledIfNoAction?: boolean;
}

const OperationButton: React.FC<IProps> = ({
  dataElementId,
  label,
  variant,
  additionalStyles = {},
  disabledIfNoAction = false,
}) => {
  const {
    theme,
    muiTheme,
    themeToken,
    action,
    defaultLabel,
    label: calculatedLabel,
    handlePressButton,
    stayEnrolledDialog,
    withdrawalUndoDialogOpen,
    handleWithdrawalUndoDialogUndo,
    handleWithdrawalUndoDialogClose,
    postWithdrawUndoLoading,
  } = useOperationButton();

  if (!action && !disabledIfNoAction) {
    return null;
  }

  return (
    <Box
      className="operation-button"
      sx={{
        display: 'flex',
        '& p': { margin: 0 },
      }}
    >
      <Button
        dataElementId={dataElementId}
        type="button"
        onClick={handlePressButton}
        variant={variant ?? ButtonVariant.PRIMARY}
        themeToken={themeToken}
        additionalStyles={[
          {
            display: 'inline-block',
            whiteSpace: 'nowrap',
          },
          additionalStyles,
        ]}
        isDisabled={disabledIfNoAction && !action}
      >
        {typeof label === 'string' ? (
          label
        ) : (
          <HtmlBox html={label ?? calculatedLabel ?? defaultLabel} />
        )}
      </Button>

      {stayEnrolledDialog && (
        <WithdrawalStayEnrolledDialog
          theme={theme}
          muiTheme={muiTheme}
          dialog={stayEnrolledDialog}
          dialogOpen={withdrawalUndoDialogOpen}
          handleDialogClose={handleWithdrawalUndoDialogClose}
          handleDialogUndo={handleWithdrawalUndoDialogUndo}
          undoLoading={postWithdrawUndoLoading}
        />
      )}
    </Box>
  );
};

export default OperationButton;
